import { ReactNode, useEffect } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  useEffect(() => {
    // Add organization structured data
    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'llm.txt Generator',
      url: 'https://llmtext.net',
      logo: 'https://llmtext.net/favicon.svg',
      description: 'Free llm.txt generator and AI SEO resource hub. Create properly formatted llm.txt files to help AI tools better understand your website.',
      sameAs: [
        'https://github.com/llmtext-net'
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        url: 'https://llmtext.net/contact'
      },
      offers: {
        '@type': 'Offer',
        name: 'Free llm.txt Generator',
        description: 'Free tool to create llm.txt files for AI optimization',
        price: '0',
        priceCurrency: 'USD'
      }
    }

    // Remove existing organization schema
    const existing = document.querySelector('script[data-schema="organization"]')
    if (existing) {
      existing.remove()
    }

    // Add new organization schema
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.setAttribute('data-schema', 'organization')
    script.textContent = JSON.stringify(organizationSchema)
    document.head.appendChild(script)
  }, [])

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
    </div>
  )
}
